import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Accordion, Icon, Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm, propTypes, formValueSelector } from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

import { ItemGridWithCart, DatePickerCustomButton } from 'Components';
import { SiteComponent } from 'Common/SiteComponent';
import { CreateEditOrderEnum, ItemEnum } from 'Common/FieldEnum';
import { CREATE_EDIT_ORDER_FORM } from 'Common/FormEnum';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { makeMultiDropdownOptionsData } from 'Common/FormHelper';
import { createKeyEventListener } from 'Common/GeneralHelper';
import {
  InputField,
  DatePickerField,
  DropdownField,
} from 'Common/SemanticWrapper';

class CreateEditOrderFormContainer extends Component {
  static propTypes = {
    ...propTypes,

    orderItemsTableName: PropTypes.string,
    orderItemsGridName: PropTypes.string,
    orderItems: PropTypes.object.isRequired,

    siteItemsTableName: PropTypes.string,
    siteItemsGridName: PropTypes.string,
    siteItems: PropTypes.array.isRequired,

    onSiteAndDeliveryDateChange: PropTypes.func.isRequired,
    orderTypes: PropTypes.array,
    orderTypesLoading: PropTypes.bool,
    onOrderTypeAdd: PropTypes.func,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    orderTypes: [],
    orderTypesLoading: false,
    onOrderTypeAdd: () => {},
    loading: false,
  };

  state = {
    accordionActive: true,
  };

  toggleAccordion = () => {
    const { accordionActive: oldActive } = this.state;
    const accordionActive = !oldActive;
    this.setState({ accordionActive });
  };

  onOrderItemsChange = (orderItem) => {
    const { change } = this.props;
    const itemCode = orderItem[ItemEnum.ItemCode];

    const newOrderItem = { _added: Date.now(), ...orderItem };

    change(
      `${CreateEditOrderEnum.TransactionDetail}['${itemCode}']`,
      newOrderItem
    );
  };

  onOrderItemRemove = (orderItem) => {
    const { orderItems, change } = this.props;

    const itemCode = orderItem[ItemEnum.ItemCode];
    const { [itemCode]: oldOrderItem, ...newOrderItems } = orderItems;

    change(CreateEditOrderEnum.TransactionDetail, newOrderItems);
  };

  handleCommentsTab = () => {
    const node = findDOMNode(this);
    const input = node.querySelector('.itemgrid-search-input > input');

    if (input) {
      input.focus();
      return true;
    }

    return false;
  };

  render() {
    const {
      onSiteAndDeliveryDateChange,
      orderTypes,
      orderTypesLoading,
      onOrderTypeAdd,
      disabled,
      loading,
      ...itemGridWithCartProps
    } = this.props;

    const { accordionActive } = this.state;

    return (
      <Form>
        <Accordion fluid styled style={{ marginBottom: '2rem' }}>
          <Accordion.Title
            active={accordionActive}
            onClick={() => this.toggleAccordion(0)}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Options</span>
          </Accordion.Title>
          <Accordion.Content active={accordionActive}>
            <Grid className="remove-spacing">
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    name={CreateEditOrderEnum.Id}
                    component={InputField}
                    type="text"
                    maxLength={50}
                    label="Order #"
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <SecurityPreferences
                    scope={PreferencesEnum.OrderDeliveryDate}
                  >
                    {(disabledFromPreference) => (
                      <Field
                        component={DatePickerField}
                        label="Delivery Date:"
                        dateFormat={DATE_FORMAT_FOR_UI}
                        name={CreateEditOrderEnum.TransactionDT}
                        onChange={(e, newValue, oldValue, field) =>
                          onSiteAndDeliveryDateChange(newValue, oldValue, field)
                        }
                        minDate={moment()}
                        type="text"
                        dropdownMode="select"
                        customInput={
                          <DatePickerCustomButton
                            fluid
                            isDisabled={
                              disabledFromPreference || disabled || loading
                            }
                          />
                        }
                        fluid
                        style={{ maxWidth: '188px' }}
                        disabled={disabled || loading}
                      />
                    )}
                  </SecurityPreferences>
                </Grid.Column>
                <Grid.Column width={4}>
                  <SiteComponent
                    name={CreateEditOrderEnum.SiteId}
                    isForm={true}
                    label="Site"
                    isAllRequired={false}
                    showAllActiveSites={true}
                    onChange={(newValue, oldValue, field) =>
                      onSiteAndDeliveryDateChange(newValue, oldValue, field)
                    }
                    disabled={disabled || loading}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field
                    name={CreateEditOrderEnum.OrderTypeDetails}
                    component={DropdownField}
                    options={makeMultiDropdownOptionsData(orderTypes)}
                    label="Order Tag"
                    placeholder="Select Order Tag"
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    onAddItem={(e, { value }) => onOrderTypeAdd(value)}
                    loading={orderTypesLoading}
                    disabled={disabled || loading}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={CreateEditOrderEnum.Comments}
                    component={InputField}
                    type="text"
                    maxLength="50"
                    label="Comments"
                    onKeyDown={createKeyEventListener({
                      onTab: this.handleCommentsTab,
                    })}
                    disabled={disabled || loading}
                    hideError={true}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>

        <ItemGridWithCart
          onOrderItemsChange={this.onOrderItemsChange}
          onOrderItemRemove={this.onOrderItemRemove}
          showCalc={false}
          disabled={disabled}
          loading={loading}
          {...itemGridWithCartProps}
        />
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};

  //all items in order must have a quantity set
  const orderItems = values[CreateEditOrderEnum.TransactionDetail];

  for (let itemCode in orderItems) {
    if (orderItems.hasOwnProperty(itemCode)) {
      const {
        [ItemEnum.PriQty]: priQty,
        [ItemEnum.SecQty]: secQty,
      } = orderItems[itemCode];

      if (!parseInt(priQty, 10) && !parseInt(secQty, 10)) {
        errors[CreateEditOrderEnum.TransactionDetail] =
          'All items in order must have a purchase quantity or pack quantity';
      }
    }
  }

  return errors;
};

const CreateEditOrderFormForm = reduxForm({
  form: CREATE_EDIT_ORDER_FORM,
  validate,
})(CreateEditOrderFormContainer);

const mapStateToProps = (state) => {
  const selector = formValueSelector(CREATE_EDIT_ORDER_FORM);

  return {
    //https://github.com/redux-form/redux-form/issues/2253
    //https://github.com/redux-form/redux-form/issues/4344
    orderItems: selector(state, [CreateEditOrderEnum.TransactionDetail]) || {},
  };
};

export const CreateEditOrderForm = connect(
  mapStateToProps,
  null
)(CreateEditOrderFormForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/components/createEditOrder/CreateEditOrderForm.js